import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import WhatIsCorporateAcademy from './components/WhatIsCorporateAcademy';
import WhenNeeded from './components/WhenNeeded';
import WhyTrainingFails from './components/WhyTrainingFails';
import AcademyStructure from './components/AcademyStructure';
import AcademyElements from './components/AcademyElements';
import BusinessResults from './components/BusinessResults';
import ImplementationProcess from './components/ImplementationProcess';
import AcademyVsExternal from './components/AcademyVsExternal';
import TypicalMistakes from './components/TypicalMistakes';
import WorkFormats from './components/WorkFormats';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const academyNavLinks = [
  { label: 'Что это', target: 'what-is' },
  { label: 'Структура', target: 'structure' },
  { label: 'Элементы', target: 'elements' },
  { label: 'Внедрение', target: 'implementation' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function CorporateAcademyPage() {


  return (
    <>
      
      <SeoTitle title="Корпоративная академия | Business Training" />
      <PageJsonLd />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={academyNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <div id="what-is">
          <WhatIsCorporateAcademy />
        </div>
        <WhenNeeded />
        <WhyTrainingFails />
        <div id="structure">
          <AcademyStructure />
        </div>
        <div id="elements">
          <AcademyElements />
        </div>
        <div id="results">
          <BusinessResults />
        </div>
        <div id="implementation">
          <ImplementationProcess />
        </div>
        <AcademyVsExternal />
        <TypicalMistakes />
        <WorkFormats />
        <WhyWorkWithMe />
        <CTASection />
        <FAQSection />
        <LeadMagnetBlock variant="compact" />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}